import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import { intl } from 'di18n-react';
/*
 * @Author: hypocrisy
 * @Date: 2024-04-12 14:29:09
 * @LastEditors: songjunlong
 * @LastEditTime: 2025-02-28 09:30:59
 * @FilePath: \node-master\src\service\core\request.ts
 */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import axios from 'axios';
axios.defaults.baseURL = '/api/v1';
axios.defaults.timeout = 60 * 1000 * 10;
import FormData from 'form-data';
import { ApiError } from './ApiError';
import { CancelablePromise } from './CancelablePromise';
export const isDefined = value => {
  return value !== undefined && value !== null;
};
export const isString = value => {
  return typeof value === 'string';
};
export const isStringWithValue = value => {
  return isString(value) && value !== '';
};
export const isBlob = value => {
  return typeof value === 'object' && typeof value.type === 'string' && typeof value.stream === 'function' && typeof value.arrayBuffer === 'function' && typeof value.constructor === 'function' && typeof value.constructor.name === 'string' && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
export const isFormData = value => {
  return value instanceof FormData;
};
export const isSuccess = status => {
  return status >= 200 && status < 300;
};
export const base64 = str => {
  try {
    return btoa(str);
  } catch (err) {
    // @ts-ignore
    return Buffer.from(str).toString('base64');
  }
};
export const getQueryString = params => {
  const qs = [];
  const append = (key, value) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process = (key, value) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach(v => {
          process(key, v);
        });
      } else if (typeof value === 'object') {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };
  Object.entries(params).forEach(([key, value]) => {
    process(key, value);
  });
  if (qs.length > 0) {
    return `?${qs.join('&')}`;
  }
  return '';
};
const getUrl = (config, options) => {
  const encoder = config.ENCODE_PATH || encodeURI;
  const path = options.url.replace('{api-version}', config.VERSION).replace(/{(.*?)}/g, (substring, group) => {
    if (options.path?.hasOwnProperty(group)) {
      return encoder(String(options.path[group]));
    }
    return substring;
  });
  const url = `${config.BASE}${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};
export const getFormData = options => {
  if (options.formData) {
    const formData = new FormData();
    const process = (key, value) => {
      if (isString(value) || isBlob(value)) {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    };
    Object.entries(options.formData).filter(([_, value]) => isDefined(value)).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => process(key, v));
      } else {
        process(key, value);
      }
    });
    return formData;
  }
  return undefined;
};
export const resolve = async (options, resolver) => {
  if (typeof resolver === 'function') {
    return resolver(options);
  }
  return resolver;
};
export const getHeaders = async (config, options, formData) => {
  const [token, username, password, additionalHeaders] = await Promise.all([resolve(options, config.TOKEN), resolve(options, config.USERNAME), resolve(options, config.PASSWORD), resolve(options, config.HEADERS)]);
  const formHeaders = typeof formData?.getHeaders === 'function' && formData?.getHeaders() || {};
  const headers = Object.entries({
    Accept: 'application/json',
    ...additionalHeaders,
    ...options.headers,
    ...formHeaders
  }).filter(([_, value]) => isDefined(value)).reduce((headers, [key, value]) => ({
    ...headers,
    [key]: String(value)
  }), {});
  if (isStringWithValue(localStorage.getItem('nms_token'))) {
    headers['Authorization'] = `Bearer ${localStorage.getItem('nms_token')}`;
  }
  if (isStringWithValue(username) && isStringWithValue(password)) {
    const credentials = base64(`${username}:${password}`);
    headers['Authorization'] = `Basic ${credentials}`;
  }
  if (options.body !== undefined) {
    if (options.mediaType) {
      headers['Content-Type'] = options.mediaType;
    } else if (isBlob(options.body)) {
      headers['Content-Type'] = options.body.type || 'application/octet-stream';
    } else if (isString(options.body)) {
      headers['Content-Type'] = 'text/plain';
    } else if (!isFormData(options.body)) {
      headers['Content-Type'] = 'application/json';
    }
  }
  return headers;
};
export const getRequestBody = options => {
  if (options.body) {
    return options.body;
  }
  return undefined;
};
export const sendRequest = async (config, options, url, body, formData, headers, onCancel, axiosClient) => {
  const source = axios.CancelToken.source();
  const requestConfig = {
    url,
    headers,
    data: body ?? formData,
    method: options.method,
    withCredentials: config.WITH_CREDENTIALS,
    cancelToken: source.token
  };
  onCancel(msg => source.cancel(msg || 'The user aborted a request.'));
  try {
    return await axiosClient.request(requestConfig);
  } catch (error) {
    const axiosError = error;
    if (axiosError.response) {
      return axiosError.response;
    }
    throw error;
  }
};
export const getResponseHeader = (response, responseHeader) => {
  if (responseHeader) {
    const content = response.headers[responseHeader];
    if (isString(content)) {
      return content;
    }
  }
  return undefined;
};
export const getResponseBody = response => {
  if (response.status !== 204) {
    return response.data;
  }
  return undefined;
};
export const catchErrorCodes = (options, result) => {
  const errors = {
    400: 'Bad Request',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Not Found',
    500: 'Internal Server Error',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    ...options.errors
  };
  const error = errors[result.status];
  if (error) {
    throw new ApiError(options, result, error);
  }
  if (!result.ok) {
    const errorStatus = result.status ?? 'unknown';
    const errorStatusText = result.statusText ?? 'unknown';
    const errorBody = (() => {
      try {
        return JSON.stringify(result.body, null, 2);
      } catch (e) {
        return undefined;
      }
    })();
    throw new ApiError(options, result, `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`);
  }
};

/**
 * Request method
 * @param config The OpenAPI configuration object
 * @param options The request options from the service
 * @param axiosClient The axios client instance to use
 * @returns CancelablePromise<T>
 * @throws ApiError
 */
export const request = (config, options, axiosClient = axios) => {
  return new CancelablePromise(async (resolve, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const formData = getFormData(options);
      const body = getRequestBody(options);
      const headers = await getHeaders(config, options, formData);
      if (!onCancel.isCancelled) {
        const response = await sendRequest(config, options, url, body, formData, headers, onCancel, axiosClient);
        const responseBody = getResponseBody(response);
        const responseHeader = getResponseHeader(response, options.responseHeader);
        const result = {
          url,
          ok: isSuccess(response.status),
          status: response.status,
          statusText: response.statusText,
          body: responseHeader ?? responseBody
        };
        catchErrorCodes(options, result);
        if (result.body.code !== 200) {
          _Notification.error({
            title: intl.t('提示'),
            content: result.body.data || result.body.msg,
            duration: 3000
          });
          if (result.body.code === 1003) {
            localStorage.removeItem('nms_token');
            localStorage.removeItem('nms_userName');
            localStorage.removeItem('nms_userStatus');
            window.location.href = '/nms/login';
          }
        }
        if (result.body.code === 200) {
          resolve(result.body.data);
        } else {
          reject(result.body.data || result.body.msg);
        }
      }
    } catch (error) {
      _Notification.error({
        title: intl.t('提示'),
        content: error.message || intl.t('服务器错误'),
        duration: 3000
      });
      reject(error);
    }
  });
};